import { Component } from 'react';
import './App.css';
import toast, { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContent } from "./Redux/Actions/contentAction";
import { getStores } from "./Redux/Actions/storeAction";
import { getSeasonalMenus } from "./Redux/Actions/seasonalMenuAction";
import { getUsers, login, logout, refreshLogin } from "./Redux/Actions/userAction";
import Content from "./views/content/Content";
import Login from "./views/login/Login";
import User from "./views/user/User";
import {
  getScreens,
  screenStatusActive,
  screenStatusDeActive,
} from "./Redux/Actions/screenAction";
import Screen from "./views/screen/Screen";
import Playlist from "./views/playlist/Playlist";
import { getPlaylist } from "./Redux/Actions/playlistAction";
import ForgetPassword from "./views/login/ForgetPassword";
import Dashboard from "./views/dashboard/Dashboard";
import Setting from "./views/setting/Setting";
import Store from "./views/store/Store";
import StorePortal from "./views/storeportal/StorePortal";
import TLJ from "./views/tlj/TLJ";
import StoreForm from "./views/storeform/StoreForm";
import MenuForm from "./views/menuform/MenuForm";
import MenuMaster from "./views/menuMaster/MenuMaster";
import SeasonalMenu from "./views/seasonalmenu/SeasonalMenu";
import Payment from "./views/payment/Payment";
import socket, { setSocketAuth } from './socket';
import { api } from './api/api';
import PrivacyPolicy from './views/privacypolicy/PrivacyPolicy';
import ChangePassword from './views/login/ChangePassword';
import SetPassword from './views/login/SetPassword';
import {useRefreshLogin} from './hooks/useRefreshLogin';
import { Box } from '@mui/material';
import loginBackgroundIMG from "./Assets/images/login-background.png";
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

function App() {
  const dispatch = useDispatch();
  const { user ,auth} = useSelector((state) => state.User);
  const {loading}=useRefreshLogin();
  
  let timer;
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      logoutAction();
    }, 5*60*1000);
  };
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };
  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);
  const logoutAction = () => {
    // resetTimer();
    dispatch(logout())
    // window.location.pathname = "/login";
  };


  // 로그인 후 소켓에 JWT 인증 적용 (admin 명령 활성화)
  useEffect(() => {
    if (!auth) return;
    api.get('/user/socket-token').then(res => {
      if (res.data?.token) setSocketAuth(res.data.token);
    }).catch(() => {});
  }, [auth]);

  const socketRef = useRef();
  useEffect(() => {
    const connection = () => {
      // 싱글톤 소켓 인스턴스를 ref에 할당 (이미 연결된 소켓 재사용)
      socketRef.current = socket;

      socketRef.current.emit('join',
      {"detail":{"mac":"2ea4b7118a097c88","device_details":{"ip":"192.168.232.2","height":1600,"width":2560,"os_version":"7.1.1","manufacture":"Google","device_name":"Google Android SDK built for x86","software":"1.0","root_level":true},"ram":{"total":"3038 MB","free":"2507 MB"},"storage":{"total":"2006 MB","free":"1771 MB"}}}
  )
      // socketRef.current.emit('ActivateScreen',{codes:'7686',mac:'2b:3c:9d:12:yu'})
      // socketRef.current.emit('join',{"detail":{"mac":"fb43171416bda42e"}})
      socketRef.current.on("screen", (data) => {
        console.log(data);
      });
      socketRef.current.on('message_recieved',({message})=>{
        if(message){
          toast.success('message successfully')
        }
      })
      socketRef.current.on("admin_screen", ({ detail, left }) => {
        console.log(detail);
        dispatch(screenStatusActive(detail.mac, true));
      });
      socketRef.current.on("leave", (obj) => {
        console.log(obj);
        dispatch(screenStatusDeActive(obj.mac, false));
      });
      // Store screenshot events are handled directly in Store.jsx via socketRef
    };
    connection();
  }, []);
  useEffect(() => {
    const effectiveUserId = user?.user?._id || user?._id;
    dispatch(getContent(effectiveUserId));
    dispatch(getScreens(user?._id));
    dispatch(getUsers(effectiveUserId));
    dispatch(getPlaylist(effectiveUserId));
    dispatch(getStores(effectiveUserId));
    dispatch(getSeasonalMenus(effectiveUserId));
  }, []);
  return loading ? (<>
  <Box
   sx={{
    minHeight: "100vh",
    maxWidth: "100vw",
    backgroundImage: `url(${loginBackgroundIMG})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    position: "relative",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  }}
  >
<Box sx={{
  position:'absolute',
  top:0,
  right:0,
  bottom:0,
  left:0,
  display:'flex',
  justifyContent:'center',
  alignItems:'center'
}}>
   <img src='/images/spiner.gif'/>
</Box>
  </Box>
 
  </>) : (
    <div className="App">
    <Toaster
      position={"top-right"}
      toastOptions={{
        duration: 3000,
      }}
    />
    <BrowserRouter>
      <Routes>
        <Route exact path={"/changepassword/:id/:token"} element={<ChangePassword/>} />
        <Route exact path={"/setpassword/:id/:token"} element={<SetPassword/>} />
        <Route exact path={"/store-form/:token"} element={<StoreForm />} />
        <Route exact path={"/menu-form/:token"} element={<MenuForm />} />
        <Route exact path={"/forgetpassword"} element={<ForgetPassword />} />
        <Route exact path={'/privacypolicy'} element={<PrivacyPolicy/>}/>
        <Route exact path={"/login"} element={<Login />} />
        <Route element={<PrivateRouter/>}>
          <Route
            exact
            path={"/"}
            element={<Dashboard user={user} />}
          />
          <Route
            exact
            path={"/content"}
            element={<Content user={user} socketRef={socketRef} />}
          />
          <Route exact path={"/user"} element={<User user={user} socketRef={socketRef} />} />
          <Route
            exact
            path={"/screen"}
            element={<Screen user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/playlist"}
            element={<Playlist user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/setting/:id"}
            element={<Setting user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/store"}
            element={<Store user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/seasonal"}
            element={<SeasonalMenu user={user} />}
          />
          <Route
            exact
            path={"/payment"}
            element={<Payment user={user} />}
          />
          <Route
            exact
            path={"/storeportal"}
            element={<StorePortal user={user} />}
          />
          <Route
            exact
            path={"/tlj"}
            element={<TLJ user={user} />}
          />
          <Route
            exact
            path={"/menu-master"}
            element={<MenuMaster user={user} />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  </div>
  );
}
function PrivateRouter() {
  const { auth } = useSelector((state) => state.User);
  return (
    <>
    {auth ? <Outlet /> : <Navigate to={'/login'} />}
    </>
  )
}
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif',
          background: '#f8f7ff', color: '#333', padding: 32,
        }}>
          <h2 style={{ color: '#551FFF', marginBottom: 16 }}>페이지를 불러오는 중 오류가 발생했습니다</h2>
          <pre style={{
            background: '#fff', border: '1px solid #ddd', borderRadius: 8,
            padding: 16, maxWidth: 600, overflow: 'auto', fontSize: 13,
          }}>
            {this.state.error?.toString()}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 24, padding: '10px 24px', background: '#551FFF',
              color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer',
              fontSize: 15,
            }}
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function AppWithErrorBoundary() {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

export default AppWithErrorBoundary;
